// extracted by mini-css-extract-plugin
export default {"ul":"FooterList_ul__c6jyh","footerContainer":"FooterList_footerContainer__V0xom","content":"FooterList_content__6ABpp","h4":"FooterList_h4__0Bg5h"};